import { PlanStatus } from "@src/gql/graphql";
import { useMyPlanSuspense } from "../queries/fetch-plan";
import {
	type FeatureGateInput,
	type FeatureGateProps,
	type FeatureGateResult,
	type FeatureStats,
	isFeatureEnabled,
	useNormalizedFeatures,
} from "./base";
import { FeatureGateRender } from "./render-feature-gate";

export type SessionFeatureGateProps = {
	feature?: FeatureGateInput;
} & FeatureGateProps;

export const SessionFeatureGate = (props: SessionFeatureGateProps) => {
	const { feature: featureProp, ...rest } = props;

	const { data: plan } = useMyPlanSuspense();

	const features = plan?.features ?? [];
	const normalized = useNormalizedFeatures(featureProp, "session");
	const sessionConfigs = normalized.filter(
		(config) => config.scope === "session",
	);

	let enabled =
		plan.status === PlanStatus.Active ||
		plan.status === PlanStatus.InTrial ||
		plan.status === PlanStatus.Cancelled;
	let stats: FeatureStats | undefined;
	const details = sessionConfigs.map<FeatureGateResult>((config) => ({
		...config,
		enabled: true,
	}));

	for (const [index, config] of sessionConfigs.entries()) {
		const feature = features.find((f) => f.feature === config.feature);
		const { enabled: enabledFeature, stats: statsFeature } =
			isFeatureEnabled(feature);

		enabled = enabled && enabledFeature;
		details[index] = {
			...config,
			enabled: enabledFeature,
			stats: statsFeature,
		};

		if (statsFeature) {
			stats = statsFeature;
		}

		if (!enabled) {
			break;
		}
	}

	if (stats) {
		return (
			<FeatureGateRender
				{...rest}
				enabled={enabled}
				stats={stats}
				details={details}
			/>
		);
	}

	return <FeatureGateRender {...rest} enabled={enabled} details={details} />;
};
